var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCabriolet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.053 9.854a.228.228 0 00-.43.101v1.229H3.026a.227.227 0 00-.227.227v2.911c0 .104.07.195.172.22l2.911.729a.229.229 0 00.055.006h.072a1.681 1.681 0 002.768 0h8.149a1.681 1.681 0 002.768 0h.799c.035 0 .07-.008.101-.024l1.456-.728a.228.228 0 00.126-.203v-1.456a.227.227 0 00-.067-.16l-.728-.728a.228.228 0 00-.123-.064l-4.332-.722-4.336-2.168a.227.227 0 10-.204.407l3.506 1.753H9.718l-.665-1.33zM7.394 15.55a1.23 1.23 0 01-1.228-1.228 1.23 1.23 0 011.228-1.228 1.23 1.23 0 011.229 1.228 1.23 1.23 0 01-1.229 1.228zm10.917 0a1.23 1.23 0 111.228-1.228 1.23 1.23 0 01-1.228 1.228z",
    fill: "#0B0B0B",
    fillRule: "evenodd"
  })));
}

export default SvgCabriolet;